var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex",attrs:{"tile":"","flat":""}},[_c('v-sheet',{staticClass:"pa-4"},[_c('v-img',{attrs:{"src":_vm.imagesrc}}),_c('v-card-text',[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }